import React, { useCallback, useState, useEffect } from 'react'
import { Prompt } from 'react-router'
import { ConfirmModal } from '../modal'
import { withRouter } from 'react-router-dom'

const EditorTransitionPrompt = ({ when, history, location: historyLocation }) => {
  const [location, setLocation] = useState(null)
  const [prompt, setShowPrompt] = useState(false)
  const [forceTransition, setForceTransition] = useState(null)

  const handleTransition = useCallback(location => {
    if (!forceTransition && when &&
          location.pathname !== historyLocation.pathname) {
      setLocation(location)
      setShowPrompt(true)
      return false
    }
    return true
  }, [forceTransition, historyLocation.pathname, when])

  const handleConfirm = useCallback(() => setForceTransition(true), [])

  useEffect(() => {
    if ((location && location.pathname === '/login')) {
      setForceTransition(true)
      history.push(location.pathname)
    } else if (forceTransition) {
      history.push(location.pathname)
    }
  }, [forceTransition, history, location])

  return (
    <React.Fragment>
      <Prompt when={forceTransition ? false : when} message={handleTransition} />
      {
        prompt && (
          <ConfirmModal
            isOpened
            onClose={() => setShowPrompt(false)}
            onConfirm={handleConfirm}
            redConfirm
          >
              You have unsaved changes. Do you really want to leave?
          </ConfirmModal>
        )
      }
    </React.Fragment>
  )
}

export default withRouter(EditorTransitionPrompt)
